import 'hammerjs';

import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database-deprecated';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CoursesModule } from './courses/courses.module';
import { LecturesModule } from './lectures/lectures.module';
import { LessonsModule } from './lessons/lessons.module';
import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';
import { UsersModule } from './users/users.module';
import { UiModule } from "./ui/ui.module";
import { SyllabusesModule } from "./syllabuses/syllabuses.module";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    CoreModule.forRoot(),
    PagesModule,
    SharedModule,
    UsersModule,
    CoursesModule,
    LecturesModule,
    LessonsModule,
    AppRoutingModule,
    UiModule,
    SyllabusesModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/app.module.ts